// 授权及授权结果页
<template>
  <div v-loading.fullscreen.lock="fullLoading">
    <div class="logo-sty">
    </div>
    <div class="auth-sty">
      <div class="result-sty" v-if="authComplete">
        <el-result icon="success" title="授权成功" subTitle="">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="turnBack">{{`完成${turnCount > 0 ? `（${turnCount}S）` :
              ''}`}}
            </el-button>
          </template>
        </el-result>
      </div>
      <template v-else>
        <div class="content-box">
          <h1 class="res-title"><img src="/images/pc_enterprise.png" alt="qiye" style="width: 25px; margin:0 1%">授权申请</h1>
          <div class="content">
          <p class="res-titleII">{{`您${authInfo && authInfo.userType ==1 ? '的企业' :
            ''}正在通过（${authInfo.creator.username}）的平台上申请开通`}}<span class="res-span">电子签名服务，请完成授权。</span></p>
            <h1 style="margin-bottom:10px">确认授权后 （{{authInfo.creator.username}}）将获得以下权限：</h1>
            <!-- 企业 -->
            <template v-if="authInfo && authInfo.userType ==1">
              <p class="auth-item">获取您的企业基本信息</p>
              <p class="auth-item">授权访问您的电子签数据：合同数据、下载签署文件、签署任务信息、签署任务创建及发起、印章管理</p>
              <p class="auth-item">授权管理并使用您的秘钥（AppKey）</p>
            </template>
            <template v-else>
              <p class="auth-item">获取您的身份信息</p>
              <p class="auth-item">授权访问您的电子签数据：合同数据、下载签署文件、签署任务信息、签署任务创建及发起</p>
            </template>
            <!-- 验证方式 -->
            <template v-if="authInfo.linkType === 2">
              <h1>
                <span>验证方式：</span>
                <el-select v-model="activeNav" placeholder="请选择" @change="ChangeFn">
                  <el-option
                    v-for="item in options"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </h1>
              <div>
                <!--      验证码验证        -->
                <template v-if="activeNav === 1">
                  <h1>授权账户：</h1>
                  <p style="margin:2% 0">{{accountInfo.referEmail || accountInfo.referMobile}}<span
                    v-show="accountInfo.name || authInfo.name">{{ `（${accountInfo.name || authInfo.name}）` }}</span></p>
                  <el-input placeholder="请输入内容" size="small" v-model="AuthCode" class="code-input-sty">
                    <el-button slot="append" :disabled="isCountDown" @click="verifyHandle">{{isCountDown ?
                      `${codeCountDown} S` : '获取验证码'}}
                    </el-button>
                  </el-input>
                </template>
                <!--      法定代表人人脸验证        -->
                <template v-else-if="activeNav === 2">
                  <h1>授权账户：</h1>
                  <p style="margin: 2px 0 12px">{{accountInfo.referEmail || accountInfo.referMobile}}<span
                    v-show="accountInfo.name || authInfo.name">{{ `（${accountInfo.name || authInfo.name}）` }}</span></p>
                  <h1>法定代表人姓名：</h1>
                  <p style="margin: 2px 0 12px">{{authInfo.lbLegalName}}</p>
                  <h1>法定代表人身份证号：</h1>
                  <p style="margin: 2px 0 12px">{{authInfo.lbLegalIdentityCard}}</p>
                </template>
                <!--      通知法定代表人人脸验证        -->
                <template v-else-if="activeNav === 3">
                  <h1>授权账户：{{accountInfo.referEmail || accountInfo.referMobile}}<span
                    v-show="accountInfo.name || authInfo.name">{{ `（${accountInfo.name || authInfo.name}）` }}</span></h1>
                  <ul class="submit_list">
                    <li
                      :class="['list_once', { active: activeTableSecond === 1 }]"
                      @click="activeTableSecondFn(1)"
                    >
                      <span class="radio"></span>
                      <span>分享二维码/链接</span>
                    </li>
                    <li
                      :class="[
                'list_once list_once2',
                { active: activeTableSecond === 2 },
              ]"
                      @click="activeTableSecondFn(2)"
                    >
                      <span class="radio"></span>
                      <span>直接发送短信</span>
                    </li>
                  </ul>
                  <!--   二维码     -->
                  <div class="qrcode_box" v-show="activeTableSecond === 1">
                    <qrcode :value="QRCodeValue" :size="140" leave="H" key="evidence" />
                    <div class="qrcode_btn">
                      <el-button
                        class="qrcode_href_copy"
                        :data-clipboard-text="QRCodeValue"
                        @click="copyHrefFn('.qrcode_href_copy')"
                        size="small"
                      >复制链接</el-button>
                      <el-button type="danger" @click="getProfileFn(1)" size="small">查询认证结果</el-button>
                    </div>
                  </div>
                  <!--   短信     -->
                  <div class="sms_box" v-show="activeTableSecond === 2">
                    <!--   通知后等待       -->
                    <div v-if="smsAuthVisible" class="sms_loading">
                      <i class="el-icon-time" style="color: #ec1c1c; font-size: 38px; font-weight: bold"></i>
                      <p style="margin: 20px 0">
                        已向法定代表人 {{authInfo.lbLegalName}}发送认证短信，请及时通知法定代表人完成认证！
                      </p>
                      <div>
                        <el-button @click="smsAgainFn(0)" size="small">修改手机号</el-button>
  <!--                      <el-button @click="smsAgainFn(1)" size="small">再次发送短信</el-button>-->
                        <el-button type="danger" @click="getProfileFn(1)" size="small">查询认证结果</el-button>
                      </div>
                    </div>
                    <!--   短信通知       -->
                    <el-form
                      v-else
                      :model="moblieData"
                      :rules="phoneRules"
                      class="sms_form"
                      ref="moblieDataRef"
                      size="small"
                      label-width="150px"
                    >
                      <el-form-item prop="smsPhone" label="法定代表人手机号:">
                        <el-input
                          :maxlength="11"
                          :minlength="11"
                          v-model="moblieData.smsPhone"
                          placeholder="法定代表人手机号"
                        />
                      </el-form-item>
                      <el-form-item style="text-align: center; padding-top: 15px">
                        <aliCaptcha
                          :verify="getPhoneCode"
                          :mobile="moblieData.smsPhone"
                          :verifyType="BUSITYPE.LEGALPERSON"
                          :handCallback="handCallback"
                        >
                          <el-button size="small" type="danger">确认发送</el-button>
                        </aliCaptcha>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <h1>授权账户：</h1>
              <p style="margin:2% 0">{{accountInfo.referEmail || accountInfo.referMobile}}<span
                v-show="accountInfo.name || authInfo.name">{{ `（${accountInfo.name || authInfo.name}）` }}</span></p>
            </template>
          </div>
          <el-button type="primary" style="width:80%; margin:20px 0" @click="authConfrim">{{activeNav === 3 && activeTableSecond === 2 ? '已完成授权' : '确认授权'}}</el-button>
        </div>
      </template>
    </div>
    <AliCaptcha
      v-show="false"
      :handCallback="countdownLe"
      :targetId="accountInfo.emailOrPhone"
      :verifyType='BUSITYPE.AuthSendVerifiy'
    >
      <button ref="aliCaptchaRef">发送验证码</button>
    </AliCaptcha>
    <!--    -->
    <el-dialog title="人脸识别认证" :visible.sync="faceCodeVisible" width="600px">
      <div class="wrap">
        <p class="tip">请扫描二维码或复制链接，在手机上完成人脸认证</p>
        <div class="images">
          <qrcode class="qr" :value="faceAuthUrl" :size="194" level="H"></qrcode>
          <img class="img-tip" src="../../../../components/face-auth-qrcode/face-tip.png">
        </div>
        <el-row>
          <el-col :span="17">
            <el-input readonly :value="faceAuthUrl"></el-input>
          </el-col>
          <el-col :span="6" style="float: right;">
            <el-button class="qrCodeLink" @click="copyHrefFn('.qrCodeLink')" :data-clipboard-text="faceAuthUrl" type="danger">复制链接</el-button>
          </el-col>
        </el-row>
        <p class="text-tip">
          <i style="color: #ec1c1c;" class="el-icon-warning"></i>
          每个二维码或对应的链接只能使用<span style="color: #ec1c1c; font-weight: 600;">1</span>次,
          链接有效期<span style="color: #ec1c1c; font-weight: 600;">10</span>分钟
          <span class="refresh" @click="refreshCode">重新获取</span>
        </p>
<!--        <el-button v-if="!circleCallback" class="complete-btn" @click="complete" type="danger" :style="computedStyle" size="small">已完成认证</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import GlobalConfig from "@/assets/js/config/global";
  import {BUSITYPE} from "@/assets/js/utils/others";
  import AliCaptcha from '../../../../components/send-auth-validcode/aliCaptchaNew.vue';
  // API
  import {ApiMethods} from "@/assets/js/http-serve/http-methods";
  // tool
  import {mapGetters} from 'vuex'
  import Clipboard from "clipboard";
  import {isInDingTalk} from "../../../../assets/js/utils/ding-env";
  import Qrcode from "qrcode.vue";
  import {mobile} from "../../../../assets/js/lib/valid-methods";

  export default {
    components: {
      AliCaptcha,
      Qrcode,
    },
    data() {
      // 这里存放数据
      return {
        activeNav: 1,
        accountInfo: {name: '', emailOrPhone: ''},
        authComplete: false,
        turnCount: 0, // 跳转倒计时
        AuthCode: '',
        codeCountDown: 0,
        fullLoading: false,
        authInfo: {
          creator: {
            username: ''
          },
          grantorAuthType: []
        },
        BUSITYPE,
        junziqanIndex: GlobalConfig.domain.junziqanIndex,
        //法定代表人人脸识别
        faceCodeVisible: false,
        faceAuthUrl: '', //人脸地址

        //通知法定代表人人脸识别
        activeTableSecond: 1,
        QRCodeValue: '',//二维码
        smsAuthVisible: false,
        moblieData: {
          smsPhone:  ''
        },
        phoneRules: {
          smsPhone: [{ validator: mobile, trigger: "blur" }],
        },
      //  轮询定时器
        intervalTime: null,
      }
    },
    // 监听属性 类似于data概念
    computed: {
      ...mapGetters(["allAuthUser"]),
      /** 是否正在倒计时 */
      isCountDown() {
        return this.codeCountDown > 0
      },
      options(){
        const veriOptions = [
          {key:1,label:'验证码验证'},
          {key:2,label:'法定代表人人脸验证'},
          {key:3,label:'通知法定代表人人脸验证'}
        ];
        const list = veriOptions.filter((item)=>this.authInfo.grantorAuthType.includes(item.key));
        return list;
      }
    },
    // 方法集合
    methods: {
      ChangeFn(val) {
        if (val === 3) {
          this.intervalTimeFn();
        }
      },
      //卡片切换2
      activeTableSecondFn (val) {
        this.activeTableSecond = val;
      },
      refreshCode(){
        this.getFaceUrlFn()
      },
      //  复制
      copyHrefFn (className) {
        const clipboard = new Clipboard(className);
        clipboard.on("success", e => {
          this.$message({
            type: "success",
            message: "复制成功"
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          // 不支持复制
          this.$message({
            type: "waning",
            message: "该浏览器不支持自动复制"
          });
          // 释放内存
          clipboard.destroy();
        });
      },
      smsAgainFn (type) {
        this.moblieData.smsPhone = '';
        this.smsAuthVisible = false;
      },
      // 获取手机验证码 前置校验
      getPhoneCode (callback) {
        this.$refs['moblieDataRef'].validateField('smsPhone', (error) => {
          if (!error) {
            // this.bankValidCode.showImageCode = true;
            if (callback) callback()
          }
        });
      },
      handCallback () {
        this.smsAuthVisible = true
      },
      //  查询结果
      getProfileFn (clickBtn) {
        let param = {...this.$route.query}
        // if (this.isCreate) {
        //   param.need_splice = base64.encode(JSON.parse(Cookie.get("e_token"))); // 要替换的token
        // }
        ApiMethods.stateless.queryAuthStatus(param).then(res => {
          if (res.success) {
            if (res.data) {
              this.authSuccessFn();
              if (isInDingTalk) {
                const session = sessionStorage;
                const dingloginInfo = JSON.parse(session.getItem("dingloginInfo"));
                // this.$router.replace({
                //   path: `/login/middle?corpId=${dingloginInfo.dingTalkCorpId}`
                // })
              }else{
                // this.$router.replace({
                //   path: '/viewIndex'
                // })
              }
            } else {
              clickBtn && this.$message.warning('当前未完成授权，请联系法定代表人确认授权进度！')
            }
          } else {
            this.$message.error(res.description)
          }
        })
      },
      /** 发送短信验证码倒计时 倒计时120S */
      countdownLe() {
        let interval = null
        this.codeCountDown = 120
        interval = setInterval(() => {
          this.codeCountDown--
          if (this.codeCountDown === 0) clearInterval(interval)
        }, 1000)
      },
      /** 获取认证信息 */
      getAuthInfo() {
        const _this = this;
        this.loadingStart();
        ApiMethods.stateless.advancedAuthInfo({...this.$route.query}).then(
          res => {
            if (!res.success){
              this.$message.error(res.description)
              if(res.data.failBackUrl){
                location.href = res.data.failBackUrl;
              }
              return;
            };
            _this.authInfo = res.data;
            _this.activeNav = res.data.grantorAuthType[0];
            const {authorized,sourcePage,userType,linkType} = res.data;
            if(userType == 1 && linkType === 2){
              this.getFaceUrlFn(); //获取人脸链接
              this.getQrcodeUrlFn(); //获取二维码链接
            }
            if (authorized && authorized == 1) {
              _this.$alert('该账号授权已完成', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  _this.turnBack()
                }
              });
            }
          }
        ).finally(() => {
          this.loadingClose()
        })
      },
      /** 人脸认证链接 */
      getFaceUrlFn() {
        ApiMethods.stateless.faceUrlAuth({...this.$route.query}).then(res => {
          if(!res.success){
            return this.$message.error(res.description)
          }
          this.faceAuthUrl = res.data;
        })
      },
      /** 法人信息qrcode */
      getQrcodeUrlFn() {
        ApiMethods.stateless.authQrcode({...this.$route.query}).then(res => {
          this.QRCodeValue = res.data;
        })
      },

      //提交
      authConfrim() {
        const {linkType} = this.authInfo;
        if(linkType === 2){
          switch (this.activeNav) {
            case 1:
              this.authConfrimFn1()
              break;
            case 2:
              this.intervalTimeFn();
              this.faceCodeVisible = true;
              break;
            case 3:
              this.getProfileFn(1);
              break;
            default:
              break;
          }
        }else{
          this.fastAuthConfrim();
        }
      },
      //轮询
      intervalTimeFn() {
        if (!this.intervalTime) {
          this.intervalTime = setInterval(() => {
            this.getProfileFn();
          }, 2000)
        }
      },
      /** 确认授权 */
      async authConfrimFn1() {
        this.loadingStart()
        const FD = new FormData()
        FD.append('multiSignatoryKey', this.$route.query.multiSignatoryKey)
        FD.append('valicode', this.AuthCode)
        FD.append('ts', this.$route.query.ts)
        FD.append('sign', this.$route.query.sign)
        FD.append('uid', this.$route.query.uid)
        ApiMethods.stateless.userAuth(FD).then(res => {
          if (!res.success) return this.$message.error(res.description)
          this.authSuccessFn();
        }).finally(() => {
          this.loadingClose()
        })
      },
      /** 认证及授权方式的确认授权 */
      async fastAuthConfrim() {
        this.loadingStart()
        const FD = new FormData()
        FD.append('multiSignatoryKey', this.$route.query.multiSignatoryKey)
        FD.append('valicode', this.AuthCode)
        FD.append('ts', this.$route.query.ts)
        FD.append('sign', this.$route.query.sign)
        FD.append('uid', this.$route.query.uid)
        ApiMethods.stateless.userFastAuth(FD).then(res => {
          if (!res.success) return this.$message.error(res.description)
          this.authSuccessFn();
        }).finally(() => {
          this.loadingClose()
        })
      },
      //authSuccess
      authSuccessFn() {
        this.faceCodeVisible = false;
        this.authComplete = true
        this.turnCountDown(3)
        //清除定时器
        if (this.intervalTime) {
          clearInterval(this.intervalTime);
        }
        this.$message.success('已完成授权');
      },
      /** 跳转倒计时 */
      turnCountDown(num) {
        this.turnCount = num
        setTimeout(() => {
          this.turnCount--
          if (this.turnCount <= 0) {
            this.turnBack()
          } else {
            this.turnCountDown(this.turnCount)
          }
        }, 1000)
      },
      /** 跳转回调 */
      turnBack() {
        const backUrl = this.authInfo.backUrl
        if (backUrl) {
          window.location.href = backUrl;
        } else {
          this.$router.replace({path: '/viewIndex'})
        }
      },
      /** 触发阿里验证 */
      verifyHandle(params) {
        // 获取到验证码组件ref
        const aliCaptchaRef = this.$refs.aliCaptchaRef
        // 触发验证码组件点击事件
        aliCaptchaRef.click()
      },
      loadingStart() {
        this.fullLoading = true
      },
      loadingClose() {
        this.fullLoading = false
      },
      /** 获取当前账号信息 */
      getUserInfo() {
        ApiMethods.stateless.profile({...this.$route.query}).then(res => {
          const {data} = res;
          const {accountInfoVO: MAIN} = data ? data : this.allAuthUser;
          this.$storeInstance.commit("SET_ALL_AUTH_USER", data);
          // 账户主体是企业类型 MAIN.userType == 1 否则 个人
          this.accountInfo = {
            ...MAIN,
            emailOrPhone: (MAIN && MAIN.userType == 1) ? MAIN.emailMask : MAIN.mobileMash
          }
        })
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.getUserInfo();
      this.getAuthInfo();
    },
    beforeDestroy() {
      if (this.intervalTime) {
        clearInterval(this.intervalTime); // 清除定时器
      }
      // 移除sassApi认证标记
      localStorage.removeItem('markApi');
    },
    layout: "user",
  }
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  .auth-sty {
    text-align: center;
    width: 50%;
    padding-top: 10px;
    background: #fff;
    border-radius: 5px;
    margin: 6% auto 0 auto;
    min-height: 60vh;

    .content-box {
      font-size: 16px;

      .res-title {
        text-align: left;
        font-size: 18px;
      }

      .content {
        width: 80%;
        text-align: left;
        margin: 20px auto;
        .res-titleII {
          .res-span {
            line-height: 3;
            font-size: 16px;
            font-weight: bolder;
          }
        }

        .auth-item {
          line-height: 2;

          &::before {
            content: '';
            display: inline-block;
            width: 0.5vw;
            height: 0.5vw;
            background: #000;
            border-radius: 50%;
            margin-right: 1%;
          }
        }
        .submit_list {
          display: flex;
          justify-content: center;
          margin-bottom: 15px;

          .list_once {
            padding: 7px;
            cursor: pointer;
            font-size: 14px;

            .radio {
              display: inline-block;
              width: 6px;
              height: 6px;
              border: 4px solid #a0a0a0;
              background-color: #ffffff;
              border-radius: 50%;
              margin-right: 4px;
            }

            .radio_title {
            }

            &.list_once2 {
              margin-left: 40px;
            }

            &.active {
              border-bottom: 4px solid #ec1c1e;

              span {
                color: #ec1c1e;
              }

              .radio {
                width: 6px;
                height: 6px;
                border: 4px solid #ec1c1e;
                background-color: #ffffff;
              }
            }
          }
        }

        .qrcode_box {
          text-align: center;
          .qrcode_btn {
            margin-top: 20px;
          }
        }
        .sms_box {
          text-align: center;
          margin-top: 30px;

          .sms_loading {
            border: 1px solid #d3d3d3;
            border-radius: 8px;
            padding: 20px;
          }

          .sms_form {
            width: 380px;
            margin: 0 auto;

            .img-code {
              background-color: #fff;
              display: inline-block;
              margin: 0 -20px;
              width: 100px;
              line-height: 30px;
              text-align: center;
              cursor: pointer;

              img {
                vertical-align: middle;
                display: inline-block;
                height: 30px;
                width: 100%;
              }
            }
          }
        }
      }
    }

    .result-sty {
      padding-top: 10vh;
    }

    .code-input-sty {
      margin-bottom: 10px;
    }
  }

  .logo-sty {
    position: absolute;
    top: 1.5%;
    left: 18.7%;

    img {
      // width: 320px;
      // height: 64px;
      width: 45.5%;
    }
  }
  .wrap{
    text-align: left;
    padding: 10px 60px 40px 60px;
    .tip{
      color: #979797;
    }
    .images{
      padding: 24px 10px;
      .qr {
        display: inline-block;
        vertical-align: middle;
      }
      .img-tip{
        width: calc(100% - 210px);
        margin-left: 16px;
      }
    }
    .text-tip{
      margin-top: 20px;
      i{
        margin-right: 5px;
      }
      .refresh{
        margin-left: 10px;
        color: #ec1c1c;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .complete-btn{
      display: block;
      margin: 20px auto 10px;
      width: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/auth/APIAuth/AuthRes/AuthResult.vue